import { tokensRaw } from '@vp/swan';

export const SvgIdea = ({ backgroundColor = tokensRaw.SwanBaseColorGreen100 }) => {
    return (
        <svg
            width="68"
            height="68"
            viewBox="0 0 68 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="34" cy="34" r="34" fill={backgroundColor} />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M45.88 25.123V28.3592L44.4348 29.0162L43.48 31.1167V22.84H40.624L41.7149 20.44H42.6048L44.4348 24.4661L45.88 25.123ZM39.0786 20.44H16.84C15.5145 20.44 14.44 21.5145 14.44 22.84V48.76C14.44 50.0855 15.5145 51.16 16.84 51.16H43.48C44.8055 51.16 45.88 50.0855 45.88 48.76V31.6366L43.48 36.9165V48.76H16.84V22.84H37.6596L38.0724 22.6537L39.0786 20.44Z"
                fill="black"
            />
            <path
                d="M28.5606 42.8771L33.9306 35.92L40.84 45.16H19.36L24.73 38.221L28.5606 42.8771Z"
                fill="black"
            />
            <path
                d="M51.22 23.08L52.9308 19.3308L56.68 17.62L52.9308 15.9092L51.22 12.16L49.5091 15.9092L45.76 17.62L49.5091 19.3308L51.22 23.08ZM44.395 24.445L42.12 19.44L39.845 24.445L34.84 26.72L39.845 28.9951L42.12 34L44.395 28.9951L49.3999 26.72L44.395 24.445Z"
                fill="black"
            />
        </svg>
    );
};
